import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { find } from 'lodash';
import { getTranslated } from 'utils';
import Navigation from './Navigation';

const mapStateToProps = ({ layout }) => {
    const { menuCollapsed, menuMobile, locale, userPermissions, userData, admin } = layout;

    const generateIntl = item => getTranslated(`navigation.${item}`, locale);

    const isAllowed = (group) => {
        if (userData.data?.user_group[0].name.toLowerCase() === 'operator' && group === 'errors') {
            return false;
        }

        return !!find(userPermissions?.permissions_groups, i => i.name === group);
    };

    let menuData = [
        {
            title: generateIntl('dashboard'),
            path: '/dashboard',
            icon: 'tachometer',
            key: 'dashboard',
        },

        {
            title: generateIntl('productFactory'),
            path: '',
            icon: 'cog',
            key: 'factory',
            subs: [
                {
                    title: generateIntl('carriers'),
                    path: '/factory/carriers',
                    key: 'carriers',
                },

                {
                    title: generateIntl('properties'),
                    path: '/factory/properties',
                    key: 'properties',
                },

                {
                    title: generateIntl('configurations'),
                    path: '/factory/configurations',
                    key: 'configurations',
                },

                {
                    title: generateIntl('packages'),
                    path: '/factory/packages',
                    key: 'packages',
                },

                {
                    title: generateIntl('templates'),
                    path: '/factory/templates',
                    key: 'templates-config',
                },
            ],
        },

        {
            title: generateIntl('costs'),
            key: 'costs',
            path: '/costs',
            icon: 'eur',
        },

        {
            title: generateIntl('marketing'),
            key: 'marketing',
            path: '',
            icon: 'bullhorn',
            subs: [
                {
                    title: generateIntl('productgroups'),
                    path: '/marketing/products_groups',
                    key: 'product-groups',
                },

                {
                    title: generateIntl('segments'),
                    path: '/marketing/segments',
                    key: 'segments',
                },

                {
                    title: generateIntl('discounts'),
                    path: '/marketing/discounts',
                    key: 'discounts',
                },

                {
                    title: generateIntl('promotions'),
                    path: '/marketing/promotions',
                    key: 'promotions',
                },

                {
                    title: generateIntl('translations'),
                    path: '/marketing/translations',
                    key: 'translations',
                },
            ],
        },

        {
            title: generateIntl('crm'),
            key: 'crm',
            path: '',
            icon: 'users-cog',
            subs: [
                {
                    title: generateIntl('customers'),
                    path: '/crm/customers',
                    key: 'customers',
                },
                {
                    title: generateIntl('orders'),
                    path: '/crm/orders',
                    key: 'orders',
                },
                {
                    title: generateIntl('orderItems'),
                    path: '/production/order-items',
                    key: 'order-items',
                },
            ],
        },

        {
            title: generateIntl('accountancy'),
            key: 'invoices',
            path: '',
            icon: 'calculator',
            subs: [
                {
                    title: generateIntl(`accountancy.statistics.${admin}`),
                    path: '/accountancy/statistics',
                    key: 'invoices',
                },
                {
                    title: generateIntl(`accountancy.export.${admin}`),
                    path: '/accountancy/export',
                    key: 'invoices',
                },
                {
                    title: generateIntl('accountancy.invoices'),
                    path: '/accountancy/invoices',
                    key: 'invoices',
                },
            ],
        },

        {
            title: generateIntl('designLibrary'),
            key: 'libraries',
            path: '',
            icon: 'icons',
            subs: [
                {
                    title: generateIntl('designLibrary.list'),
                    path: '/design-library/list',
                    key: 'libraries',
                },
                {
                    title: generateIntl('designLibrary.settings'),
                    path: '/design-library/settings',
                    key: 'settings',
                },
            ],
        },

        {
            title: generateIntl('logistics'),
            key: 'logistics',
            path: '',
            icon: 'truck',
            subs: [
                {
                    title: generateIntl('logistics.listing'),
                    path: '/logistics/listing',
                    key: 'logistics',
                },
                {
                    title: generateIntl('logistics.boxes'),
                    path: '/logistics/boxes',
                    key: 'package-dimension',
                },
            ],
        },

        {
            title: generateIntl('productionPlanning'),
            key: 'pp',
            path: '',
            icon: 'industry',
            subs: [
                {
                    title: generateIntl('planning'),
                    path: '/pp/planning',
                    key: 'planning',
                },

                {
                    title: generateIntl('machines'),
                    path: '/pp/machines',
                    key: 'machines',
                },

                {
                    title: generateIntl('forms'),
                    path: '/pp/forms',
                    key: 'forms',
                },

                {
                    title: generateIntl('formVersions'),
                    path: '/pp/form_versions',
                    key: 'form-versions',
                },

                {
                    title: generateIntl('rollsIn'),
                    path: '/pp/rolls_in',
                    key: 'rolls-in',
                },

                {
                    title: generateIntl('rollsOut'),
                    path: '/pp/rolls_out',
                    key: 'rolls-out',
                },

                {
                    title: generateIntl('jobs'),
                    path: '/pp/jobs',
                    key: 'jobs',
                },

                {
                    title: generateIntl('jobResults'),
                    path: '/pp/job_results',
                    key: 'palettes',
                },

                {
                    title: generateIntl('coatingIn'),
                    path: '/pp/coating_in',
                    key: 'palettes',
                },

                {
                    title: generateIntl('coatingOut'),
                    path: '/pp/coating_out',
                    key: 'palettes',
                },

                {
                    title: generateIntl('packaging'),
                    path: '/pp/packaging',
                    key: 'packaging',
                },

                {
                    title: generateIntl('reprint'),
                    path: '/pp/reprint',
                    key: 'packaging',
                },

                {
                    title: generateIntl('errors'),
                    path: '/pp/errors',
                    key: 'errors',
                },
            ],
        },

        {
            title: generateIntl('users'),
            key: 'users',
            path: '',
            icon: 'users',
            subs: [
                {
                    title: generateIntl('userListing'),
                    path: '/users/listing',
                    key: 'users',
                },

                {
                    title: generateIntl('userGroups'),
                    path: '/users/groups',
                    key: 'user-groups',
                },
            ],
        },

        {
            title: generateIntl('advancedSettings'),
            key: 'settings',
            path: '',
            icon: 'tools',
            subs: [
                {
                    title: generateIntl('emailTemplates'),
                    path: '/settings/email-templates',
                    key: 'email-templates',
                },
                {
                    title: generateIntl('paymentTypes'),
                    path: '/settings/payment-types',
                    key: 'payment-type',
                },
                {
                    title: generateIntl('stores'),
                    path: '/settings/stores',
                    key: 'stores',
                },
                {
                    title: generateIntl('shippingTypes'),
                    path: '/settings/shipping-types',
                    key: 'shipping-types',
                },
                {
                    title: generateIntl('partners'),
                    path: '/settings/partners',
                    key: 'partners',
                },
                {
                    title: generateIntl('resellers'),
                    path: '/settings/shops',
                    key: 'resellers',
                },
            ],
        },
    ];

    if (admin === 'mercuryflooring') {
        menuData = menuData.filter(m => !['production'].includes(m.key));
    }

    return {
        menuData: menuData.filter((item) => {
            if (item.key === 'dashboard' || item.key === 'production') {
                return true;
            }

            if ('subs' in item) {
                return item.subs.filter(subitem => isAllowed(subitem.key)).length > 0;
            }

            return isAllowed(item.key);
        }).map((item) => {
            if ('subs' in item) {
                const modifiedItem = item;
                modifiedItem.subs = item.subs.filter(subitem => isAllowed(subitem.key));
                return modifiedItem;
            }

            return item;
        }),
        menuCollapsed,
        menuMobile,
        userPermissions,
    };
};

export default withRouter(connect(mapStateToProps, null)(Navigation));
